import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c4cdfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OCriarEvento__SelecionarAtividade" }
const _hoisted_2 = { for: "lanca-atividade" }
const _hoisted_3 = { class: "OCriarEvento__Conteudo" }
const _hoisted_4 = {
  key: 1,
  class: "OCriarEvento__Etapas"
}
const _hoisted_5 = {
  key: 2,
  class: "OCriarEvento__SemAtributos"
}
const _hoisted_6 = { class: "OCriarEvento__Profissional" }
const _hoisted_7 = {
  key: 0,
  class: "OCriarEvento__ProfissionalCriar",
  "data-testid": "OCriarEvento__ProfissionalCriar"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-user" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "OCriarEvento__ProfissionalEditar",
  "data-testid": "OCriarEvento__ProfissionalEditar"
}
const _hoisted_10 = { class: "OCriarEvento__Periodo" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-clock" }, null, -1))
const _hoisted_12 = { class: "OCriarEvento__Projeto" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-map" }, null, -1))
const _hoisted_14 = {
  key: 3,
  class: "OCriarEvento__ComAtributos"
}
const _hoisted_15 = { class: "OCriarEvento__Footer" }
const _hoisted_16 = {
  key: 1,
  class: "OCriarEvento__BotoesDeAcao"
}

import { computed, ComputedRef, onMounted, onUnmounted, reactive, ref } from "vue"
  import Dialog from "primevue/dialog"
  import AButton from "primevue/button"
  import { MDropdown, MCalendario, AEtapas } from "@/components/Gerais"
  import { OAvatarProfissional } from "@/components/Profissionais"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import { ABotaoDeAcao } from "@/components/Calendario"
  import { EntidadeGenerica } from "@/types/gerais"
  import AtividadesRealizadasRepositorio from "@/repositorios/atividades/atividades.repositorio"
  import {
    Atividade,
    AtividadesParams,
    AtualizarAtividade,
    CriarAtividade,
  } from "@/repositorios/atividades/atividades.modelos"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import TiposDeAtividadeRepositorio from "@/repositorios/tiposDeAtividade/tiposDeAtividade.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"
  import {
    ListarTiposDeAtividade,
    ParamsTiposDeAtividade,
  } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { useVuelidate } from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"
  import { estados } from "@/types/api"

  import { Erro } from "@/repositorios/erros"
  import { ProjetoRepositorio } from "@/repositorios/projeto/projeto.repositorio"
  import {
    ListarProjetos,
    ProjetosComAtividadesDoProjeto,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import SessaoServico from "@/servicos/sessao.service"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarBuscarMaisDados } from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"
  import { ListarTiposDeAtividadeComAtributos } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"
  import { storeToRefs } from "pinia"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos"
  import { CaracteristicaComValor } from "@/components/AtributoComValor/index.interfaces"
  import MarcacoesRepositorio from "@/repositorios/marcacoes/marcacoes.repositorio"
  import { CriarMarcacao } from "@/repositorios/marcacoes/marcacoes.modelos"

  /* interfaces */
  interface Props {
    visible: boolean
    destinos?: string
    modo: "criar" | "editar"
    idEvento?: string
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
  }
  interface EmitirVisibilidade {
    (event: "update:visible", visible: boolean): void
    (event: "onRecarregarAtividades"): void
  }
  /* props */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCriarEvento',
  props: {
    visible: { type: Boolean },
    destinos: null,
    modo: { default: "criar" },
    idEvento: null,
    listaDeAtributosCaracteristicaComValor: null
  },
  emits: ["update:visible", "onRecarregarAtividades"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visible", visible: boolean): void
    (event: "onRecarregarAtividades"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, destinos?: string, modo: "criar" | "editar", idEvento?: string, listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[] }

  
  /* emitters */
  
  const emissorVisibilidade = computed({
    get() {
      return props.visible
    },
    set(visible: boolean) {
      emitir("update:visible", visible)
    },
  })

  const { t } = useI18n()

  /* dados */
  const {
    pegarDataDeHoje,
    adicionarHorasNoMomentoAtual,
    pegarSomenteData,
    pegarSomenteAsHoras,
    converterParaTimeZoneLocal,
    obterTimeZoneLocal,
    hoje,
  } = usarDataHora()

  const periodo = reactive({
    inicio: {
      data: pegarDataDeHoje(),
      hora: pegarDataDeHoje(),
    },
    fim: {
      data: adicionarHorasNoMomentoAtual(1),
      hora: adicionarHorasNoMomentoAtual(1),
    },
  })

  const { colher, verificarSeElementoTemConteudo } = usarManipuladorObjetos()
  const { leitor } = usarLeitorDeDados()
  const { escritor } = usarEscritorDeDados()
  const { onErro, onSucesso, onInfo } = usarMensagemUsuario()
  const { verificarPermissaoPorGrupo } = usarPermissionamento("Profissionais")
  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)
  const {
    buscarMaisDados,
    atualizarDadosDoRepositorio,
    reinserirDadoPreSelecionadoNaLista,
    filtrarDadosDoRepositorio,
  } = usarBuscarMaisDados()

  const atividadeRep = new AtividadesRealizadasRepositorio({
    utilizaCache: false,
  })
  const marcacoesRep = new MarcacoesRepositorio()
  const projetoRep = new ProjetoRepositorio({ utilizaCache: true })
  const profissionalRep = new ProfissionalRepositorio({ utilizaCache: true })
  const tiposDeAtividadeRep = new TiposDeAtividadeRepositorio({
    utilizaCache: true,
  })

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend,
    {
      ativo: "igual.true",
      "por-pagina": 30,
    }
  )
  const lerTiposDeAtividade = leitor<
    ListarTiposDeAtividade,
    ParamsTiposDeAtividade
  >(tiposDeAtividadeRep.listarTiposDeAtividade, {
    ativo: "igual.true",
    "por-pagina": "30",
    pagina: "0",
  })
  
  const lerTiposDeAtividadeComAtributos = leitor<ListarTiposDeAtividadeComAtributos, ParamsTiposDeAtividade>(
    tiposDeAtividadeRep.listarTiposDeAtividadeFrontend
  )

  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRep.listarProfissionaisFrontend,
    {
      ativo: "igual.true",
      "por-pagina": "30",
    }
  )
  const lerAtividadesRealizadas = leitor<Atividade, AtividadesParams>(
    atividadeRep.listarAtividadesRealizadasFrontend,
    {}
  )

  const criarAtividadesEscritor = escritor<{ id: string }, CriarAtividade>(
    atividadeRep.criarAtividadeRealizada,
    []
  )
  const profissional = ref<EntidadeGenerica>()
  const profissionalSelecionado = ref<string>("")
  const profissionais = ref<EntidadeGenerica[]>([])
  const tipoDeAtividadeSelecionado = ref<string>("")
  const projetoSelecionado = ref<string>()
  const projetos = ref<ProjetosComAtividadesDoProjeto[]>([])
  const projetosMapeados = ref<EntidadeGenerica[]>([])
  const tiposDeAtividade = ref<EntidadeGenerica[]>([])
  const atividadeEmEdicao = ref<Atividade>()

  const opcaoTipoDeAtividadePreSelecionado = ref<EntidadeGenerica>({
    id: "",
    nome: "",
  })

  const opcaoProjetoPreSelecionado = ref<ProjetosComAtividadesDoProjeto>({
    id: "",
    nomeProjeto: "",
  })

  const estagioDaRequisicao = ref<number>(estados.INICIAL)
  const etapaAtiva = ref<number>(0)
  const atributosEsperados = ref<AtributoBase[]>([])

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const regras = {
    periodo: {
      inicio: {
        data: { required: helpers.withMessage("campo obrigatório*", required) },
        hora: { required: helpers.withMessage("campo obrigatório*", required) },
      },
      fim: {
        data: { required: helpers.withMessage("campo obrigatório*", required) },
        hora: { required: helpers.withMessage("campo obrigatório*", required) },
      },
    },
    tipoDeAtividade: {
      required: helpers.withMessage("campo obrigatório*", required),
    },
    profissional: {
      required: helpers.withMessage("campo obrigatório*", required),
    },
  }
  const v$ = useVuelidate(regras, {
    periodo,
    tipoDeAtividade: tipoDeAtividadeSelecionado,
    profissional: profissionalSelecionado,
  })
  /* computeds */
  const podeVerOutroProfissionais = computed(() => {
    return verificarPermissaoPorGrupo("visualizar", "outros")
  })

  const lancandoAtividade = computed(
    () => estagioDaRequisicao.value === estados.PEDENTE
  )

  const minDataFim = computed(() => {
    const inicio = v$.value.periodo.inicio.data.$model
    return inicio ?? undefined
  }) as ComputedRef<Date | undefined>

  const maxDataInicio = computed(() => {
    const fim = v$.value.periodo.fim.data.$model
    return fim ?? hoje
  }) as ComputedRef<Date>

  const maxDataFim = computed(() => hoje)

  const rotuloBotaoSalvar = computed(() => {
    return props.modo === "editar" && props.idEvento
      ? t("salvarAlteracoes")
      : t("confirmar")
  })

  const temAtributos = computed(() => {
    return atributosEsperados.value && atributosEsperados.value.length > 0 
  })

  const deveExibirEtapas = computed(() => {
    return temAtributos.value
  })
  
  const estaCarregandoAtributos = computed(() => {
    return (
      tipoDeAtividadeSelecionado.value !== null && 
      lerTiposDeAtividadeComAtributos.resultado.status === 'pendente'
    )
  })

  const desabilitarBotaoSalvarAtividade = computed(() => {
    if (!temAtributos.value) {
      return false
    }
    return !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))
  })

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  const avancarParaProximaEtapa = (): void => {
    etapaAtiva.value = 1
  }

  /* métodos */
  const resetarFormulario = (): void => {
    periodo.inicio.data = pegarDataDeHoje()
    periodo.inicio.hora = pegarDataDeHoje()
    periodo.fim.data = pegarDataDeHoje()
    periodo.fim.hora = adicionarHorasNoMomentoAtual(1)

    profissional.value = undefined
    profissionalSelecionado.value = ""
    projetoSelecionado.value = undefined
    tipoDeAtividadeSelecionado.value = tiposDeAtividade.value[0]?.id || ""
    atributosEsperados.value = []
    atividadeEmEdicao.value = undefined
    etapaAtiva.value = 0
    caracteristicaStore.resetarCaracteristicas()
    v$.value.$reset()
  }

  const atribuirValorInicialTipoDeAtividade = async (
    idTipoDeAtividade: string
  ): Promise<void> => {
    tipoDeAtividadeSelecionado.value = idTipoDeAtividade
    await listarAtributosDoTipoDeAtividade()
  }

  const listarAtributosDoTipoDeAtividade = async (): Promise<void> => {
    if (!tipoDeAtividadeSelecionado.value) {
      atributosEsperados.value = []
      caracteristicaStore.resetarCaracteristicas()
      etapaAtiva.value = 0
      return
    }

    caracteristicaStore.resetarCaracteristicas()
    etapaAtiva.value = 0

    lerTiposDeAtividadeComAtributos.sobrescreverParametros({ id: "igual." + tipoDeAtividadeSelecionado.value })
    await lerTiposDeAtividadeComAtributos.executar()

    if (lerTiposDeAtividadeComAtributos.resultado.status === 'sucesso') {
      atributosEsperados.value = lerTiposDeAtividadeComAtributos.resultado.dados[0]?.atributosEsperados || []
    }

    if (lerTiposDeAtividadeComAtributos.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarAtributos"),
        detalhes: t("ocorreuUmErroAoBuscarAtributos"),
      })
    }
  }

  const buscarMaisTiposDeAtividade = async (): Promise<void> => {
    await buscarMaisDados(lerTiposDeAtividade, tiposDeAtividade, {
      concatenarCodigoNome: true,
    })
  }

  const mapearProjetos = (): void => {
    projetosMapeados.value = projetos.value.map((projeto) => {
      return {
        id: projeto.id,
        nome: projeto.nomeProjeto,
      }
    })
  }

  const buscarMaisProjetos = async (): Promise<void> => {
    await buscarMaisDados(lerProjetos, projetos, {
      chavesDosDados: ["id", "nomeProjeto"],
    })

    mapearProjetos()
  }
  const buscarMaisProfissionais = async (): Promise<void> => {
    await buscarMaisDados(lerProfissionais, profissionais)
  }
  const listarTiposDeAtividade = async (): Promise<void> => {
    await lerTiposDeAtividade.executar()
    await atualizarDadosDoRepositorio(lerTiposDeAtividade, tiposDeAtividade, {
      concatenarCodigoNome: true,
    })
    if (props.modo === "editar") {
      reinserirDadoPreSelecionadoNaLista(
        tiposDeAtividade,
        opcaoTipoDeAtividadePreSelecionado
      )
    }
  }

  const listarProjetos = async (): Promise<void> => {
    await lerProjetos.executar()

    if (lerProjetos.resultado.status == "sucesso") {
      await atualizarDadosDoRepositorio(lerProjetos, projetos, {
        chavesDosDados: ["id", "nomeProjeto"],
      })

      mapearProjetos()
      if (props.modo === "editar") {
        reinserirDadoPreSelecionadoNaLista(projetos, opcaoProjetoPreSelecionado)
      }
    }
  }

  const listarProfissionais = async (idProfissional?: string) => {
    const paramIdProfissional = idProfissional
      ? "igual." + idProfissional
      : undefined

    lerProfissionais.sobrescreverParametros({
      ativo: "igual.true",
      "por-pagina": "30",
      id: paramIdProfissional,
    })

    await lerProfissionais.executar()

    if (lerProfissionais.resultado.status == "sucesso") {
      profissionais.value = colher<
        ListarProfissionais,
        { id: string; nome: string }
      >(lerProfissionais.resultado.dados, ["id", "nome"])

      if (!podeVerOutroProfissionais.value) {
        buscarProfissionalDoUsuarioLogado(lerProfissionais.resultado.dados)
      }
    }
  }


  const filtrarTiposDeAtividade = (valorInserido: string): void => {
    filtrarDadosDoRepositorio(
      valorInserido,
      lerTiposDeAtividade,
      tiposDeAtividade,
      {
        concatenarCodigoNome: true,
      }
    )
  }
  const filtrarProjetos = async (valorInserido: string): Promise<void> => {
    await filtrarDadosDoRepositorio(valorInserido, lerProjetos, projetos, {
      chavesDosDados: ["id", "nomeProjeto"],
      chaveDoFiltro: "nome_projeto",
    })

    mapearProjetos()
  }
  const filtrarProfissionais = (valorInserido: string): void => {
    filtrarDadosDoRepositorio(valorInserido, lerProfissionais, profissionais)
  }
  const buscarProfissionalDoUsuarioLogado = (
    listaDeProfissionais: ListarProfissionais[]
  ): void => {
    const usuarioLogado = SessaoServico.coletarInformacoesDoUsuarioLogado()

    const profissionalEncontrado = listaDeProfissionais.find(
      (itemProfissional) =>
        itemProfissional.usuarioRelacionado?.id == usuarioLogado.id
    )
    if (!profissionalEncontrado) {
      onErro({
        resumo: t("oProfissionalNaoFoiEncontrado"),
        detalhes: t("oUsuarioQueEstaAtualmenteLogado")
      })
    }
    profissionalSelecionado.value = profissionalEncontrado
      ? profissionalEncontrado.id
      : ""
  }

  const iniciarFormModoEditar = (atividade: Atividade): void => {
    atividadeEmEdicao.value = atividade

    const inicioSalvoNoBanco = converterParaTimeZoneLocal(
      atividade.dataInicio,
      atividade.horaInicio
    )
    const fimSalvoNoBanco = converterParaTimeZoneLocal(
      atividade.dataFim,
      atividade.horaFim
    )

    profissionalSelecionado.value = atividade.profissionalQueRealizou.id
    profissional.value = atividade.profissionalQueRealizou
    tipoDeAtividadeSelecionado.value = atividade.tipoDeAtividade.id

    periodo.inicio.data = inicioSalvoNoBanco
    periodo.inicio.hora = inicioSalvoNoBanco
    periodo.fim.data = fimSalvoNoBanco
    periodo.fim.hora = fimSalvoNoBanco

    projetoSelecionado.value = atividade.projeto?.id
    opcaoTipoDeAtividadePreSelecionado.value = {
      id: atividade.tipoDeAtividade.id,
      nome: `${atividade.tipoDeAtividade.codigo} - ${atividade.tipoDeAtividade.nome}`,
    }
    opcaoProjetoPreSelecionado.value = {
      id: atividade.projeto?.id,
      nomeProjeto: atividade.projeto?.nome,
    }
  }

  const recuperarAtividadeRealizada = async (idAtividade: string) => {
    lerAtividadesRealizadas.sobrescreverParametros({
      id: "igual." + idAtividade,
    })

    await lerAtividadesRealizadas.executar()

    if (lerAtividadesRealizadas.resultado.status == "sucesso") {
      const atividades = lerAtividadesRealizadas.resultado.dados

      if (atividades.length == 0) {
        onErro({
          resumo: t("atividadeNaoEncontrada"),
          detalhes:
            `${t("aAtividadeComId")} ${idAtividade} ${t("naoFoiEncontrada")}`,
        })
      }
      iniciarFormModoEditar(lerAtividadesRealizadas.resultado.dados[0])
      await listarAtributosDoTipoDeAtividade()
    }
  }

  const fecharModal = (): void => {
    emissorVisibilidade.value = false
    resetarFormulario()
  }

  const criarNovaAtividade = async (
    atividade: CriarAtividade
  ): Promise<void> => {
    estagioDaRequisicao.value = estados.PEDENTE
    criarAtividadesEscritor.mudarArgumentos([atividade])
    await criarAtividadesEscritor.executar()

    if (criarAtividadesEscritor.resultado.status === "sucesso") {
      onSucesso({
        resumo: t("atividadeLancadaComSucesso"),
        detalhes: pegarNomeDoTipoDeAtividade(tipoDeAtividadeSelecionado.value),
      })
      emitir("onRecarregarAtividades")
      fecharModal()
      estagioDaRequisicao.value = estados.SUCESSO
    }
    if (criarAtividadesEscritor.resultado.status === "erro") {
      onErro({
        resumo: t("naoFoiPossivelLancarAtividade"),
        detalhes: criarAtividadesEscritor.resultado.mensagem,
      })

      estagioDaRequisicao.value = estados.ERRO
    }
  }
  const atualizarAtividade = async (id: string, atividade: AtualizarAtividade): Promise<void> => {
    estagioDaRequisicao.value = estados.PEDENTE

    const montarMarcacao = (tipo: "inicio" | "fim"): CriarMarcacao => ({
      tipo,
      modoDeRegistro: "manual",
      data: pegarSomenteData(periodo[tipo].data),
      hora: pegarSomenteAsHoras(periodo[tipo].hora),
      timezone: obterTimeZoneLocal(),
    })

    const sincronizarMarcacao = async (tipo: "inicio" | "fim"): Promise<void> => {
      const marcacao = montarMarcacao(tipo)
      const marcacaoAtual = atividadeEmEdicao.value?.marcacoes?.find(
        (item) => item.tipo === tipo
      )

      if (!marcacaoAtual) {
        await marcacoesRep.criarMarcacao(id, marcacao)
        return
      }

      const horarioFoiAlterado =
        marcacaoAtual.data !== marcacao.data || marcacaoAtual.hora !== marcacao.hora

      if (horarioFoiAlterado) {
        await marcacoesRep.alterarMarcacao(id, marcacaoAtual.id, {
          modoDeRegistro: marcacao.modoDeRegistro,
          data: marcacao.data,
          hora: marcacao.hora,
          timezone: marcacao.timezone,
        })
      }
    }

    const operacoes = [
      { nome: t("dadosDaAtividade"), executar: () => atividadeRep.atualizarAtividadeRealizada(id, atividade) },
      { nome: t("horarioDeInicio"), executar: () => sincronizarMarcacao("inicio") },
      { nome: t("horarioDeFim"), executar: () => sincronizarMarcacao("fim") },
    ]
    const falhas: string[] = []

    for (const operacao of operacoes) {
      try {
        await operacao.executar()
      } catch {
        falhas.push(operacao.nome)
      }
    }

    if (!falhas.length) {
      onSucesso({
        resumo: t("atividadeAtualizadaComSucesso"),
        detalhes: pegarNomeDoTipoDeAtividade(tipoDeAtividadeSelecionado.value),
      })

      emitir("onRecarregarAtividades")
      fecharModal()
      estagioDaRequisicao.value = estados.SUCESSO
    } else {
      onErro({
        resumo: t("naoFoiPossivelAtualizarAtividade"),
        detalhes: falhas.join(", "),
      })

      estagioDaRequisicao.value = estados.ERRO
    }
  }

  const lancarAtividade = async (): Promise<void> => {
    v$.value.$touch()
    if (v$.value.$invalid) {
      return
    }
    const tipoDeAtividadePossuiAtributos = caracteristicas.value.length > 0

    if (tipoDeAtividadePossuiAtributos) {
      const caracteristicasSemValorPreenchido = !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))

      if (caracteristicasSemValorPreenchido) {
        onInfo({
          resumo: t("atributosComValoresInvalidos"),
          detalhes: t("obrigatorioPreencherAtributos"),
        })
        return
      }
    }

    const atividade: AtualizarAtividade & Partial<CriarAtividade> = {
      idTipoDeAtividade: tipoDeAtividadeSelecionado.value,
      tipoDeDuracao: "quantidade_de_horas",
      idProfissionalQueRealizou: profissionalSelecionado.value,
      problemasJustificativas: [],
      justificativas: [],
      idProjeto: projetoSelecionado.value,
      timezoneInicio: obterTimeZoneLocal(),
      timezoneFim: obterTimeZoneLocal(),
    }

    if (tipoDeAtividadePossuiAtributos) {
      atividade.listaDeAtributosCaracteristicaComValor = caracteristicas.value.map(caracteristica => ({
        id: caracteristica.id,
        valor: caracteristica.valor,
      }))
    }

    if (props.modo === "criar") {
      atividade.modoDeRegistroInicio = "manual"
      atividade.modoDeRegistroFim = "manual"
      atividade.dataInicio = pegarSomenteData(periodo.inicio.data)
      atividade.horaInicio = pegarSomenteAsHoras(periodo.inicio.hora)
      atividade.dataFim = pegarSomenteData(periodo.fim.data)
      atividade.horaFim = pegarSomenteAsHoras(periodo.fim.hora)
      atividade.ativo = true
      atividade.deletado = true
      atividade.duracaoEmMinutos = 0
      criarNovaAtividade(atividade as CriarAtividade)
    }
    if (props.modo === "editar" && props.idEvento) {
      atualizarAtividade(props.idEvento, atividade)
    }
  }
  const pegarNomeDoTipoDeAtividade = (id: string): string => {
    return tiposDeAtividade.value.find(
      (tipoDeAtividade) => tipoDeAtividade.id === id
    )!.nome
  }
  const onCarregarDados = async (
    requisicoes: Promise<void>[]
  ): Promise<void> => {
    try {
      await Promise.all(requisicoes)
    } catch (error: any) {
      const erro = error as Erro
      onErro({
        resumo: erro.mensagem,
        detalhes: erro.detalhe,
      })

      estagioDaRequisicao.value = estados.ERRO
    }
  }
  const carregarDadosModoCriar = async (): Promise<void> => {
    await onCarregarDados([
      listarTiposDeAtividade(),
      listarProfissionais(),
      listarProjetos(),
    ])
    atribuirValorInicialTipoDeAtividade(tiposDeAtividade.value[0]?.id)
  }
  const carregarDadosModoEditar = async (
    idAtividade: string
  ): Promise<void> => {
    await recuperarAtividadeRealizada(idAtividade)
    await onCarregarDados([
      listarTiposDeAtividade(),
      listarProjetos()
    ])
  }
  onUnmounted(() => {
    caracteristicaStore.resetarCaracteristicas()
  })
  /* provide/injects */
  /* lifecyles */
  onMounted(() => {
    if (props.modo === "criar") {
      carregarDadosModoCriar()
    }
    if (props.modo === "editar" && props.idEvento) {
      carregarDadosModoEditar(props.idEvento)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emissorVisibilidade),
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
    "append-to": __props.destinos,
    class: "OCriarEvento",
    "data-testid": "OCriarEvento",
    "dismissable-mask": "",
    draggable: false,
    header: "Header",
    modal: true,
    style: { width: '550px' }
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)('lancarAtividadeDe')), 1),
        _createVNode(_unref(MDropdown), {
          modelValue: _unref(v$).tipoDeAtividade.$model,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).tipoDeAtividade.$model) = $event)),
            listarAtributosDoTipoDeAtividade
          ],
          onOnFiltrandoBusca: filtrarTiposDeAtividade,
          id: "OCriarEvento__TiposDeAtividade",
          "buscar-mais-itens": buscarMaisTiposDeAtividade,
          carregando: _unref(lerTiposDeAtividade).resultado.status === 'pendente',
          class: "OCriarEvento__TiposDeAtividade",
          "data-testid": "OCriarEvento__TiposDeAtividade",
          destino: __props.destinos,
          "mensagem-de-erro": _unref(v$).tipoDeAtividade.$errors[0]?.$message,
          nome: "lanca-atividade",
          "option-label": "nome",
          "option-value": "id",
          options: tiposDeAtividade.value,
          "usar-carregamento-sob-demanda": "",
          width: "480px"
        }, null, 8, ["modelValue", "carregando", "destino", "mensagem-de-erro", "options"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        (_unref(temAtributos) && etapaAtiva.value === 0)
          ? (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
              key: 0,
              onProximoPasso: avancarParaProximaEtapa,
              "esta-carregando": false,
              "fase-da-atividade": "proximoPasso"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_unref(AButton), {
                onClick: fecharModal,
                class: "OCriarEvento__Botao OCriarEvento__Submissor p-button-text p-button-danger",
                "data-testid": "OCriarEvento__Cancelar",
                disabled: _unref(lancandoAtividade),
                label: _unref(t)('cancelar')
              }, null, 8, ["disabled", "label"]),
              _createVNode(_unref(AButton), {
                onClick: lancarAtividade,
                class: "OCriarEvento__Botao p-button-success",
                "data-testid": "OCriarEvento__BotaoLancar",
                disabled: _unref(v$).$invalid || _unref(lancandoAtividade) || _unref(desabilitarBotaoSalvarAtividade) || _unref(estaCarregandoAtributos),
                label: _unref(rotuloBotaoSalvar),
                loading: _unref(lancandoAtividade)
              }, null, 8, ["disabled", "label", "loading"])
            ]))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_unref(estaCarregandoAtributos))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2rem",
              width: "50%"
            }))
          : (_unref(deveExibirEtapas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(AEtapas), {
                  onEtapaClicada: aoClicarNaEtapa,
                  clicavel: "",
                  etapas: _unref(etapas),
                  "indice-ativo": etapaAtiva.value,
                  largura: "50%"
                }, null, 8, ["etapas", "indice-ativo"])
              ]))
            : _createCommentVNode("", true),
        (etapaAtiva.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (__props.modo === 'criar' && _unref(podeVerOutroProfissionais))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_unref(MDropdown), {
                        modelValue: _unref(v$).profissional.$model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).profissional.$model) = $event)),
                        onOnFiltrandoBusca: filtrarProfissionais,
                        "buscar-mais-itens": buscarMaisProfissionais,
                        carregando: _unref(lerProfissionais).resultado.status === 'pendente',
                        class: "OCriarEvento__SelecioneProfissional",
                        "data-testid": "OCriarEvento__SelecioneProfissional",
                        destino: __props.destinos,
                        "mensagem-de-erro": _unref(v$).profissional.$errors[0]?.$message,
                        nome: "profissional",
                        "option-label": "nome",
                        "option-value": "id",
                        options: profissionais.value,
                        placeholder: _unref(t)('profissionalQueRealizou'),
                        "usar-carregamento-sob-demanda": "",
                        width: "480px"
                      }, null, 8, ["modelValue", "carregando", "destino", "mensagem-de-erro", "options", "placeholder"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (profissional.value)
                        ? (_openBlock(), _createBlock(_unref(OAvatarProfissional), {
                            key: 0,
                            "data-testid": "OCriarEvento__AvatarProfissional",
                            "email-profissional": profissional.value.email,
                            "nome-profissional": profissional.value.nome
                          }, null, 8, ["email-profissional", "nome-profissional"]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.inicio.data.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).periodo.inicio.data.$model) = $event)),
                  id: "data-inicio",
                  class: "OCriarEvento__DataInicio",
                  "data-testid": "OCriarEvento__DataInicio",
                  destino: __props.destinos,
                  "max-data": _unref(maxDataInicio),
                  "mensagem-de-erro": _unref(v$).periodo.inicio.data.$errors[0]?.$message,
                  obrigatorio: "",
                  rotulo: _unref(t)('dataDeInicio')
                }, null, 8, ["modelValue", "destino", "max-data", "mensagem-de-erro", "rotulo"]),
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.inicio.hora.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).periodo.inicio.hora.$model) = $event)),
                  id: "hora-inicio",
                  class: "OCriarEvento__HoraInicio",
                  "data-testid": "OCriarEvento__HoraInicio",
                  destino: __props.destinos,
                  "esconder-picker": true,
                  "formato-hora": "24",
                  icon: "pi pi-clock",
                  "mensagem-de-erro": _unref(v$).periodo.inicio.hora.$errors[0]?.$message,
                  "mostrar-horas": false,
                  obrigatorio: "",
                  rotulo: _unref(t)('horarioDeInicio'),
                  "somente-hora": ""
                }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "rotulo"]),
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.fim.data.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).periodo.fim.data.$model) = $event)),
                  id: "data-fim",
                  class: "OCriarEvento__DataFim",
                  "data-testid": "OCriarEvento__DataFim",
                  destino: __props.destinos,
                  "max-data": _unref(maxDataFim),
                  "mensagem-de-erro": _unref(v$).periodo.fim.data.$errors[0]?.$message,
                  "min-data": _unref(minDataFim),
                  obrigatorio: "",
                  rotulo: _unref(t)('dataDeFim')
                }, null, 8, ["modelValue", "destino", "max-data", "mensagem-de-erro", "min-data", "rotulo"]),
                _createVNode(_unref(MCalendario), {
                  modelValue: _unref(v$).periodo.fim.hora.$model,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).periodo.fim.hora.$model) = $event)),
                  id: "hora-fim",
                  class: "OCriarEvento__HoraFim",
                  "data-testid": "OCriarEvento__HoraFim",
                  destino: __props.destinos,
                  "esconder-picker": true,
                  "exibir-picker-time": false,
                  "formato-hora": "24",
                  icon: "pi pi-clock",
                  "mensagem-de-erro": _unref(v$).periodo.fim.hora.$errors[0]?.$message,
                  "mostrar-horas": false,
                  obrigatorio: "",
                  rotulo: _unref(t)('horarioDeFim'),
                  "somente-hora": ""
                }, null, 8, ["modelValue", "destino", "mensagem-de-erro", "rotulo"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_unref(MDropdown), {
                  modelValue: projetoSelecionado.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((projetoSelecionado).value = $event)),
                  onOnFiltrandoBusca: filtrarProjetos,
                  "buscar-mais-itens": buscarMaisProjetos,
                  carregando: _unref(lerProjetos).resultado.status === 'pendente',
                  class: "OCriarEvento__SelecionarProjeto",
                  "data-testid": "OCriarEvento__SelecionarProjeto",
                  destino: __props.destinos,
                  nome: "projetos",
                  "option-label": "nome",
                  "option-value": "id",
                  options: projetosMapeados.value,
                  placeholder: _unref(t)('projetos'),
                  "usar-carregamento-sob-demanda": "",
                  width: "480px"
                }, null, 8, ["modelValue", "carregando", "destino", "options", "placeholder"])
              ])
            ]))
          : _createCommentVNode("", true),
        (etapaAtiva.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_unref(MFormularioAtividadeComAtributos), {
                "atributos-esperados": atributosEsperados.value,
                "lista-de-atributos-caracteristica-com-valor": __props.listaDeAtributosCaracteristicaComValor
              }, null, 8, ["atributos-esperados", "lista-de-atributos-caracteristica-com-valor"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "append-to"]))
}
}

})